import { Link } from "react-router-dom";

import PageContainer from "../../common/PageContainer/PageContainer";
import EmptyState from "../../common/EmptyState/EmptyState";

const Four04 = () => (
  <PageContainer>
    <EmptyState
      icon="fa-solid fa-map-signs"
      title="Incomplete pass."
      message="That page doesn't exist: the link probably went out of bounds. Let's get you back to the game."
      action={
        <Link to="/" className="btn btn-primary">
          Take me home
        </Link>
      }
    />
  </PageContainer>
);

export default Four04;
